import { createEffect, createSignal, For, Match, onCleanup, onMount, Show } from "solid-js";
import { twMerge } from "tailwind-merge";

const Div = (props) => <div ref={props.ref} class={props.class} classList={props.classList}>{props.children}</div>
const Ul = (props) => <ul ref={props.ref} class={props.class} classList={props.classList}>{props.children}</ul>

const wrapperElem = {
  "div": Div,
  "ul": Ul
}

export const HorizontalScrollerGradient = (props) => {
  var containerRef;
  var wrapperRef;
  var firstSlideRef;
  var lastSlideRef;
  var middleSlideRef;
  var scrollMultiplier = props.scrollMultiplier != undefined ? props.scrollMultiplier : 1;

  const [leftArrowVisible, setLeftArrowVisible] = createSignal(false);
  const [rightArrowVisible, setRightArrowVisible] = createSignal(false);

  const scroll = (direction) => {
    if (direction == "left") {
      wrapperRef.scrollLeft -= (wrapperRef.clientWidth * scrollMultiplier);
    } else {
      wrapperRef.scrollLeft += (wrapperRef.clientWidth * scrollMultiplier);
    }
  }

  const toggleArrows = (entries) => {
    entries.forEach((entry) => {
      switch (entry.target) {
        case firstSlideRef:
          if (entry.isIntersecting) {
            setLeftArrowVisible(false);
          } else {
            setLeftArrowVisible(true);
          }
          break;

        default:
          if (entry.isIntersecting) {
            setRightArrowVisible(false);
          } else {
            setRightArrowVisible(true);
          }
          break;
      }
    });
  }

  createEffect(() => {
    if (props.hideArrows) return;

    props.slides;

    const observerOptions = {
      root: containerRef,
      rootMargin: "0px",
      threshold: 0.9
    }
    const slideObserver = new IntersectionObserver(
      toggleArrows,
      observerOptions
    )

    if(firstSlideRef) {
      slideObserver.observe(firstSlideRef);
    }

    if(lastSlideRef) {
      slideObserver.observe(lastSlideRef);
    }

    onCleanup(() => {
      slideObserver.disconnect();
    })
  })

  const wrapperSelected = props.wrapper != undefined ? props.wrapper?.toLowerCase() : "div";
  const slideArr = Object.keys(props.slides);

  return (
    <div ref={containerRef} 
      class={twMerge(
        "flex relative flex-col justify-center items-start font-bold uppercase w-full border-frame color-swatch-container",
        props.parentClass ?? ""
      )}
    >
      <Dynamic component={wrapperElem[wrapperSelected]} ref={wrapperRef} class={props.wrapperClass}>
        <For each={slideArr}>{(_, index) => {
          const isFirst = index() == 0;
          const isLast = index() == props.slides.length - 1;
          const slide = () => props.slides[index()]
          
          
          return (
            
            <Switch fallback={<Dynamic component={slide().component} {...slide().props} ref={middleSlideRef} />}>
              <Match when={isFirst}>
                <Dynamic component={slide().component} {...slide().props} ref={firstSlideRef} />
              </Match>
              <Match when={isLast}>
                <Dynamic component={slide().component} {...slide().props} ref={lastSlideRef} />
              </Match>
            </Switch>
          )
        }}</For>
      </Dynamic>
      <Show when={!props.hideArrows}>
        <div
          class="scroller-arrow left-arrow-gradient"
          classList={{
            "active": leftArrowVisible()
          }}
          onClick={() => scroll("left")}>
          <div>
            <svg viewBox="0 0 24 24" stroke-width="0.5" stroke="currentColor" fill="currentColor" class="w-8 h-8">
              <path fill-rule="evenodd" d="M7.72 12.53a.75.75 0 010-1.06l7.5-7.5a.75.75 0 111.06 1.06L9.31 12l6.97 6.97a.75.75 0 11-1.06 1.06l-7.5-7.5z" clip-rule="evenodd"></path>
            </svg>
          </div>
        </div>
        <div
          class="scroller-arrow right-arrow-gradient"
          classList={{
            "active": rightArrowVisible()
          }}
          onClick={() => scroll("right")}>
          <div>
            <svg viewBox="0 0 24 24" stroke-width="0.5" stroke="currentColor" fill="currentColor" class="w-8 h-8">
              <path fill-rule="evenodd" d="M16.28 11.47a.75.75 0 010 1.06l-7.5 7.5a.75.75 0 01-1.06-1.06L14.69 12 7.72 5.03a.75.75 0 011.06-1.06l7.5 7.5z" clip-rule="evenodd"></path>
            </svg>
          </div>
        </div>
      </Show>
    </div>
  )
}